import {useEffect, useRef} from "react";
import {useApi} from "./useApi";
import {mergeWatchHistory} from "../utils/mergeRemote";

// State + setter come from the dashboard's single useStorage instance rather
// than a useStorage call here: a second instance would write the shared
// sessionStorage key with its own stale copy of the other slice, clobbering
// the activity saved by useActivity (and vice versa).
const useWatchHistory = ({user, watchHistory, setWatchHistory}) => {
  const {fetchWatchHistory} = useApi();

  const historyRef = useRef(watchHistory);

  useEffect(() => {
    historyRef.current = watchHistory;
  }, [watchHistory]);

  useEffect(() => {
    if (!user?.customer_id && !watchHistory) return;
    // MERGE with local state, never overwrite: local can be ahead of the
    // server by up to a sync interval (see mergeRemote.js).
    fetchWatchHistory(user.customer_id).then((remote) =>
      setWatchHistory((local) => mergeWatchHistory(local, remote)),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {historyRef};
};
export default useWatchHistory;
